// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-447e87c8] .el-dialog__body{\n  padding: 10px 20px !important;\n}\n.footer[data-v-447e87c8]{\n    text-align: right;\n    position: fixed;\n    bottom: 0px;\n    left: 0;\n    right: 30px;\n    padding: 10px 20px 0px 20px;\n    background: rgb(255, 255, 255);\n    display: block;\n    z-index: 10;\n    /* user-select: none; */\n    border-top: 1px solid rgb(228, 231, 237);\n    height: 60px;\n}\n.clear[data-v-447e87c8]{\n  width: 100%;\n  height: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
